module.exports = __webpack_public_path__ + "static/shop-button-confirm-cfe11fd3ca8e0b06de6600c8f3da6b89.mp3";